import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Ticket } from '../../types';

interface TicketState {
  tickets: Ticket[];
  selectedTicket: Ticket | null;
  filters: {
    status?: string;
    priority?: string;
    type?: string;
  };
  loading: boolean;
  error: string | null;
}

const initialState: TicketState = {
  tickets: [],
  selectedTicket: null,
  filters: {},
  loading: false,
  error: null
};

const ticketSlice = createSlice({
  name: 'ticket',
  initialState,
  reducers: {
    setTickets: (state, action: PayloadAction<Ticket[]>) => {
      state.tickets = action.payload;
    },
    addTicket: (state, action: PayloadAction<Ticket>) => {
      state.tickets.unshift(action.payload);
    },
    updateTicket: (state, action: PayloadAction<Ticket>) => {
      const index = state.tickets.findIndex(t => t.id === action.payload.id);
      if (index !== -1) {
        state.tickets[index] = action.payload;
      }
      if (state.selectedTicket?.id === action.payload.id) {
        state.selectedTicket = action.payload;
      }
    },
    selectTicket: (state, action: PayloadAction<Ticket | null>) => {
      state.selectedTicket = action.payload;
    },
    setFilters: (state, action: PayloadAction<TicketState['filters']>) => {
      state.filters = action.payload;
    },
    setTicketLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setTicketError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    }
  }
});

export const {
  setTickets,
  addTicket,
  updateTicket,
  selectTicket,
  setFilters,
  setTicketLoading,
  setTicketError
} = ticketSlice.actions;

export default ticketSlice.reducer;